module.exports = "#admin {\n  width: 90%;\n  margin: 15px auto; }\n\n#logout {\n  float: right;\n  margin: 10px; }\n"